// Pre-built template block builders.
// Every helper returns a plain { type, props } node (NO id — ids are assigned when
// the template is loaded onto the canvas). props are merged over DEFAULT_BLOCK_PROPS
// so each node is always schema-complete and safe to render/export.
import { DEFAULT_BLOCK_PROPS } from '../blockDefaults'

const clone = o => JSON.parse(JSON.stringify(o))
export const blk = (type, props = {}) => ({ type, props: { ...clone(DEFAULT_BLOCK_PROPS[type]), ...props } })

export const heading = (content, props = {}) => blk('heading', { content, ...props })
export const text = (content, props = {}) => blk('text', { content, ...props })
export const button = (label, url = '#', props = {}) => blk('button', { label, url, ...props })
export const image = (src = '', props = {}) => blk('image', { src, ...props })
export const divider = (props = {}) => blk('divider', props)
export const spacer = (height = 20, props = {}) => blk('spacer', { height: String(height), ...props })
export const social = (props = {}) => blk('social', props)
export const footerBlk = (content, props = {}) => blk('footer', { content, ...props })
export const dropShadow = (props = {}) => blk('dropShadow', props)
export const headerBar = (props = {}) => blk('headerBar', props)
export const html = (content, props = {}) => blk('html', { content, ...props })

// columns(cols) where cols is an array of block-arrays (one per column).
/**
 * `cols` is one entry per column, each holding that column's block list.
 *
 * Most categories pass nested arrays — columns([[a, b], [c]]) — but fintech passes
 * bare blocks — columns([a, b]). That put a block OBJECT into columnDefs[].blocks,
 * and the loader then called .map() on it, which threw and rendered a blank screen
 * for those templates (ET_037 / the FinTech half of the reopened report).
 *
 * Accept both shapes so a single-block column doesn't need wrapping, and so no
 * template file can crash the editor by getting this subtly wrong again.
 */
export const columns = (cols, props = {}) => {
  const list = Array.isArray(cols) ? cols : [cols]
  return blk('columns', {
    columns: list.length,
    columnDefs: list.map(children => ({
      id: '',
      backgroundColor: '',
      blocks: Array.isArray(children) ? children : (children ? [children] : []),
    })),
    ...props,
  })
}

// A hero image using a solid colored placeholder (user swaps for their asset).
//
// The `.png` extension is REQUIRED, not cosmetic (ET_041): without it placehold.co
// serves image/svg+xml, and Gmail, Outlook and most other clients refuse to render
// remote SVG — every pre-built template came through with a broken-image icon where
// the hero should be. Same reason the fixed-size placeholders below carry `.png`.
export const hero = (label, bg = '2563eb', fg = 'ffffff', props = {}) =>
  image(`https://placehold.co/600x260/${bg}/${fg}.png?text=${encodeURIComponent(label)}`, { width: '100', ...props })
